<template>
  <div class="empty-state" :class="[size]">
    <span class="icon" :class="iconColorClass">
      <i :class="iconClass"></i>
    </span>
    <p class="empty-title">{{ title }}</p>
    <p class="empty-description" v-if="description">{{ description }}</p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    icon: {
      type: String,
      required: false,
      default: 'mdi-database-off'
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    },
    type: {
      type: String,
      default: "none",
      validator: (value) => ["none", "warning", "danger"].includes(value)
    },
    size: {
      type: String,
      default: "normal",
      validator: (value) => ["small", "normal", "large"].includes(value)
    }
  },
  computed: {
    iconClass() {
      return `mdi ${this.icon}`;
    },
    iconColorClass() {
      switch (this.type) {
        case "warning":
          return "is-warning";
        case "danger":
          return "is-danger";
        default:
          return "is-default";
      }
    }
  }
}
</script>

<style scoped lang="scss">
.empty-state {
  padding: 48px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  &.small {
    padding: 24px 12px;
    
    .icon {
      font-size: 38px;
      margin-bottom: 10px;
    }
    
    .empty-title {
      font-size: 16px;
    }
    
    .empty-description {
      font-size: 12px;
      max-width: 240px;
    }
  }
  
  &.large {
    padding: 64px 24px;
    
    .icon {
      font-size: 72px;
      margin-bottom: 32px;
    }
    
    .empty-title {
      font-size: 24px;
      margin-bottom: 12px;
    }
    
    .empty-description {
      font-size: 16px;
      max-width: 400px;
    }
  }
  
  .icon {
    font-size: 56px;
    margin-bottom: 24px;
    opacity: 0.8;
    
    &.is-default {
      color: var(--ld-text-secondary);
    }

    &.is-warning {
      color: var(--ld-status-warning);
    }

    &.is-danger {
      color: var(--ld-status-danger);
    }
  }

  .empty-title {
    font-size: 20px;
    font-weight: 500;
    color: var(--ld-text-primary);
    margin-bottom: 2px;
  }

  .empty-description {
    color: var(--ld-text-secondary);
    font-size: 14px;
    max-width: 300px;
    line-height: 1.4;
  }
}
</style> 